import React,{ useEffect, useState } from 'react';
import { connect, } from 'react-redux'
import { fetchAllPost, updatePost } from "../../../redux";
import { Link } from 'react-router-dom';
import { getAllPosts } from '../../../redux/post/postSelectors';

import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Pagination from "@mui/material/Pagination";
import { formatDate } from '../../../Utils/stringFunctions';

function PostTable(props) {
  const [page, setPage] = useState(1);
  const [posts, setPosts] = useState(null);
  const {post, fetchAllPost, updatePost} = props;
  const limit = 6;
  const post_count = post.post?.data?.count ? parseInt(post.post?.data?.count) : 0;
  const page_count = Math.ceil(post_count / limit);
  
  useEffect(() => {
    setPosts(post.post?.data?.results);
  }, [post])

  const handlePublish = async (postId, isPostPublish) => {
    await updatePost({
      id: postId,
      value: { post_publish: !isPostPublish },
    }).then((res) => {
      if(res.payload.status === 200) {
        setPosts(posts.map((post) => {
          if(post.id === postId) {
            return {
              ...post,
              post_publish: !isPostPublish
            }
          }
          return post;
        }))
      }
    });
  };

  useEffect(() => {
    fetchAllPost({limit: limit, offset: 0});
  }, [])

  const handleChange = (e, p) => {
    setPage(p);
    fetchAllPost({limit: limit,offset: (p - 1) * limit});
  };

  return (
    <>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="posts table">
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>Title</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Author</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Updated</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {posts && posts.map((row) => (
              <TableRow 
                key={row?.id} 
                sx={{ 
                  '&:hover': { backgroundColor: '#f9f9f9' },
                  '&:last-child td, &:last-child th': { border: 0 }
                }}
              >
                <TableCell>
                  <Box>
                    <Typography 
                      variant="subtitle1" 
                      sx={{ 
                        fontWeight: 500,
                        color: '#1976d2',
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' }
                      }}
                      component={Link}
                      to={'/dashboard/post/'+row.id}
                    >
                      {row?.post_title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" display="block">
                      /{row?.post_slug}
                    </Typography>
                  </Box>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">
                    {row?.post_author}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Chip 
                    label={row?.post_publish ? "Published" : "Draft"} 
                    size="small"
                    color={row?.post_publish ? "success" : "default"}
                    variant={row?.post_publish ? "filled" : "outlined"}
                  />
                </TableCell>
                <TableCell>
                  <Typography variant="body2" color="text.secondary">
                    {formatDate(row?.post_updated_date)}
                  </Typography>
                </TableCell>
                <TableCell align="center">
                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                    <IconButton 
                      size="small" 
                      component={Link} 
                      to={'/dashboard/post/'+row.id}
                      color="primary"
                      title="Edit post"
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                    <IconButton 
                      size="small" 
                      onClick={() => handlePublish(row.id, row.post_publish)}
                      color={row?.post_publish ? "warning" : "success"}
                      title={row?.post_publish ? "Unpublish" : "Publish"}
                    >
                      {row?.post_publish ? <VisibilityOffIcon fontSize="small" /> : <VisibilityIcon fontSize="small" />}
                    </IconButton>
                  </Box>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      
      {posts && posts.length === 0 && (
        <Box sx={{ textAlign: 'center', py: 4 }}>
          <Typography variant="body1" color="text.secondary">
            No posts found. Create your first post to get started.
          </Typography>
        </Box>
      )}

      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
        <Pagination
          count={page_count}
          variant="outlined"
          onChange={handleChange}
          page={page}
          color="primary"
        />
      </Box>
    </>
  );
}

const mapStateToProps = state => {
  return {
    post: getAllPosts(state),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAllPost: (data) => dispatch(fetchAllPost(data)),
    updatePost: ({ id, value }) => dispatch(updatePost({ id, value })),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PostTable)

